import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  xs12: "",
  class: "p-3"
}
const _hoisted_2 = ["innerHTML"]

import QuestionRadio from './QuestionRadio.vue'
import QuestionCheckBox from './QuestionCheckBox.vue'
import QuestionSelect from './QuestionSelect.vue'
import ProgressQuestion from './ProgressQuestion.vue'
import Simplemde from './Simplemde.vue'
import { useExamTestQuestionBody } from './useExamTestQuestionBody'
import Question from '../../models/question'
import Exam from '../../models/exam'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamTestQuestionBodyMobile',
  props: {
    exam: {},
    currentQuestion: {},
    index: {},
    time: {}
  },
  emits: ["changeValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const {
  value,
  text,
  show,
  content,
  textareaOnChange,
  callBackChange,
  callBackChangeOne
} = useExamTestQuestionBody(props, emit)

return (_ctx: any,_cache: any) => {
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(show))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "question-body-preview-client subheading",
          innerHTML: _unref(content)
        }, null, 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    (!__props.currentQuestion.isDescriptionQuestion)
      ? (_openBlock(), _createBlock(_component_v_layout, { key: 1 }, {
          default: _withCtx(() => [
            (__props.currentQuestion.isTextarea && _unref(show))
              ? (_openBlock(), _createBlock(Simplemde, {
                  key: 0,
                  name: `markdownEditor_q_${__props.currentQuestion.id}`,
                  ref: `markdownEditor_q_${__props.currentQuestion.id}`,
                  modelValue: _unref(text),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(text) ? (text).value = $event : null)),
                  onInput: _unref(textareaOnChange),
                  rows: __props.currentQuestion.textareaRowNumber,
                  "preview-class": "markdown-body",
                  class: "w-full"
                }, null, 8 /* PROPS */, ["name", "modelValue", "onInput", "rows"]))
              : (__props.currentQuestion.isCheckbox || __props.currentQuestion.isMultiCheckbox)
                ? (_openBlock(), _createBlock(QuestionCheckBox, {
                    key: 1,
                    list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                    fieldType: __props.currentQuestion.fieldType,
                    callBackChange: _unref(callBackChange),
                    value: _unref(value) ? _unref(value) : [],
                    readonly: __props.time === 0
                  }, null, 8 /* PROPS */, ["list", "fieldType", "callBackChange", "value", "readonly"]))
                : (__props.currentQuestion.isRadio)
                  ? (_openBlock(), _createBlock(QuestionRadio, {
                      key: 2,
                      list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                      callBackChange: _unref(callBackChangeOne),
                      value: _unref(value).length ? _unref(value).find((x) => !!x) : '',
                      readonly: __props.time === 0
                    }, null, 8 /* PROPS */, ["list", "callBackChange", "value", "readonly"]))
                  : (__props.currentQuestion.isSelect)
                    ? (_openBlock(), _createBlock(QuestionSelect, {
                        key: 3,
                        list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                        callBackChange: _unref(callBackChange),
                        value: _unref(value) ? _unref(value) : [],
                        readonly: __props.time === 0
                      }, null, 8 /* PROPS */, ["list", "callBackChange", "value", "readonly"]))
                    : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})